import { render, staticRenderFns } from "./DetailListTable.vue?vue&type=template&id=fc20074a&scoped=true&"
import script from "./DetailListTable.vue?vue&type=script&lang=js&"
export * from "./DetailListTable.vue?vue&type=script&lang=js&"
import style0 from "./DetailListTable.vue?vue&type=style&index=0&id=fc20074a&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc20074a",
  null
  
)

export default component.exports